import CompanyDashboardHomeModule from './containers/companyDashboardHomeModule'

export {default as CompanyDashboardHomeModuleLayout} from './components/companyDashboardHomeModuleLayout'

export default CompanyDashboardHomeModule
